export default __webpack_public_path__ + "static/media/qr-code.4d35118f.svg";